import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class MantenedorProveedorService
{
    constructor(private http: HttpClient) { }

    muestraListaProveedores(buscador:any){
        return this.http.post(`${environment.urlApiPrestamo}/getProveedores/filtro`,{
            
               
                numeroPagina: buscador?.currentPage,
                tamanioPagina: buscador?.itemsPerPage
         
        }, 
        { headers: this.armaCabecera() } ).toPromise();
    }
    traeCategoriaConvenio(){
        return this.http.get(`${environment.urlApiPrestamo}/getTipoConvenio`,
        { headers:this.armaCabecera() }).toPromise();
    }
  
    traeCantidadCuotas(){
       
        return this.http.get(`${environment.urlApiPrestamo}/getCantidadCuotasConvenio`,
        { headers:this.armaCabecera() }).toPromise(); 
    }
    traeDatosProveedor(idProveedor:any){
        {
            return this.http.get(`${environment.urlApiPrestamo}/proveedor/${idProveedor}`,
                   { headers : this.armaCabecera() }).toPromise();
        } 
    }
    ingresarProveedor(idUsuario:any, proveedor:any){
       
        return this.http.post(`${environment.urlApiPrestamo}/proveedor/agregar`,
        {
            rut:proveedor.rut,
            idProveedor:proveedor.idProveedor,
            idRegion: proveedor.idRegion,
            idComuna: proveedor.idComuna,
            direccion: proveedor.direccion,            
            nombreCorto: proveedor.nombreCorto,
            nombreProveedor: proveedor.nombreProveedor,
            idCategoria: proveedor.idCategoria,
            idCuotas: proveedor.idCuotas,
            minCuotas:proveedor.minCuotas,
            pinNm : proveedor.codigoFin
        },
        { headers : this.armaCabecera() }).toPromise();
    }

    buscarProveedor(rutBuscado: any){
        console.log("rut a buscar", rutBuscado);
        return this.http.get(`${environment.urlApiPrestamo}/buscar/porRut/${rutBuscado}`,
        { headers : this.armaCabecera() }).toPromise()

    }
    traeComunas(idRegion: any)
    {
        return this.http.get(`${environment.urlApiUsuario}/comunas/${idRegion}`, { headers: this.armaCabecera() } ).toPromise()
    }

    traeRegiones()
    {
        return this.http.get(`${environment.urlApiUsuario}/regiones`, { headers: this.armaCabecera() } ).toPromise()
    }


    traeRegionesEspeciales()
    {
        return this.http.get(`${environment.urlApiUsuario}/regionesConvenios`, { headers: this.armaCabecera() } ).toPromise()
    }
    

    editarProveedor(proveedor: any){
     
        return this.http.post(`${environment.urlApiPrestamo}/proveedor/editar`,
        {
            rut:proveedor.rut,
            idProveedor:proveedor.idProveedor,
            idRegion: proveedor.idRegion,
            idComuna: proveedor.idComuna,
            direccion: proveedor.direccion,            
            nombreCorto: proveedor.nombreCorto,
            nombreProveedor: proveedor.nombreProveedor,
            idCategoria: proveedor.idCategoria,
            idCuotas: proveedor.idCuotas,
            minCuotas:proveedor.minCuotas,
            pinNm : proveedor.codigoFin,
            visibleConvenio: proveedor.visibleConvenio
        }
        , { headers: this.armaCabecera() } ).toPromise()
    }

    modificarEstado(idUsuario: any, estadoAfiliado: any)
    {
        console.log("estadoAfiliado!!! service:",estadoAfiliado)
        return this.http.post(`${environment.urlApiPrestamo}/proveedor/modificar/estados`,
        { idProveedor: idUsuario, estado: estadoAfiliado }, { headers : this.armaCabecera() }).toPromise();
    }

    armaCabecera()
    {
        return new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        })
    }
    
}
